import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal",
  id: "rule_config_modal",
  tabindex: "-1",
  role: "dialog",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = {
  class: "modal-body",
  id: "rule_config_modal_body"
}
const _hoisted_7 = {
  class: "alert alert-danger alert-dismissible show rule-error",
  role: "alert"
}
const _hoisted_8 = { class: "form-group mb-3" }
const _hoisted_9 = { class: "input-group" }
const _hoisted_10 = { class: "form-group mb-3 triple-row" }
const _hoisted_11 = { class: "input-group" }
const _hoisted_12 = ["value"]
const _hoisted_13 = ["title"]
const _hoisted_14 = { class: "input-group" }
const _hoisted_15 = {
  id: "range",
  class: "form-control grey"
}
const _hoisted_16 = { class: "form-group mb-3" }
const _hoisted_17 = { class: "input-group" }
const _hoisted_18 = {
  key: [null],
  value: [null]
}
const _hoisted_19 = {
  key: null,
  value: null
}
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "table" }
const _hoisted_22 = { scope: "row" }
const _hoisted_23 = ["onUpdate:modelValue"]
const _hoisted_24 = {
  key: 0,
  class: "d-flex justify-content-between align-items-center mb-1"
}
const _hoisted_25 = { class: "text-muted" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "border p-1 mb-2" }
const _hoisted_28 = { class: "form-group mb-3" }
const _hoisted_29 = { class: "list-group-flush p-0" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "form-group row" }
const _hoisted_32 = { class: "input-group col" }
const _hoisted_33 = ["onUpdate:modelValue", "onChange"]
const _hoisted_34 = ["value"]
const _hoisted_35 = { class: "input-group col" }
const _hoisted_36 = ["onUpdate:modelValue", "disabled"]
const _hoisted_37 = ["value"]
const _hoisted_38 = ["onClick", "disabled"]
const _hoisted_39 = {
  key: 1,
  class: "text-center text-muted mb-2 or-divider"
}
const _hoisted_40 = { class: "form-group mb-3 row" }
const _hoisted_41 = { class: "input-group col" }
const _hoisted_42 = { class: "input-group col" }
const _hoisted_43 = { class: "form-group mb-3" }
const _hoisted_44 = { class: "input-group" }
const _hoisted_45 = { class: "form-group form-check" }
const _hoisted_46 = { class: "form-group form-check" }
const _hoisted_47 = { class: "form-group form-check" }
const _hoisted_48 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_feather = _resolveComponent("vue-feather")!
  const _component_datepicker = _resolveComponent("datepicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, "Configure " + _toDisplayString(_ctx.Name), 1),
          _createElementVNode("button", {
            type: "button",
            class: "close",
            "data-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearSelectedRule && _ctx.clearSelectedRule(...args)))
          }, [...(_cache[16] || (_cache[16] = [
            _createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
          ]))])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("div", _hoisted_7, [
            _cache[18] || (_cache[18] = _createElementVNode("strong", null, "Error:", -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.errorMessage) + " ", 1),
            _createElementVNode("button", {
              type: "button",
              class: "close",
              "data-dismiss": "alert",
              "aria-label": "Close",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.errorMessage = ''))
            }, [...(_cache[17] || (_cache[17] = [
              _createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
            ]))])
          ], 512), [
            [_vShow, _ctx.errorMessage]
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[19] || (_cache[19] = _createElementVNode("div", { class: "input-group-text" }, "Name", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  type: "text",
                  id: "desc",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.Name) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.Name]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[20] || (_cache[20] = _createElementVNode("div", { class: "input-group-text" }, "Task", -1)),
                _withDirectives(_createElementVNode("select", {
                  id: "range",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.TaskID) = $event)),
                  onChange: _cache[4] || (_cache[4] = ($event: any) => {
                    _ctx.sourceData = _ctx.getPropertyForTask(_ctx.TaskID, 'InputTable');
                    _ctx.updateParameterOptions(_ctx.TaskID);
                  })
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tasks, (task) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: task.TaskID,
                      value: task.TaskID
                    }, _toDisplayString(task.Name), 9, _hoisted_12))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.TaskID]
                ])
              ]),
              _createElementVNode("div", {
                class: "icon-container",
                title: _ctx.getPropertyForTask(_ctx.TaskID, 'Documentation')
              }, [
                _createVNode(_component_vue_feather, { type: "info" })
              ], 8, _hoisted_13),
              _createElementVNode("div", _hoisted_14, [
                _cache[21] || (_cache[21] = _createElementVNode("div", { class: "input-group-text" }, "Data", -1)),
                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.sourceData), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _cache[22] || (_cache[22] = _createElementVNode("div", { class: "input-group-text" }, "Input Data Source", -1)),
                _withDirectives(_createElementVNode("select", {
                  id: "range",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.DataTaskRuleIDs) = $event))
                }, [
                  (_openBlock(), _createElementBlock("option", _hoisted_18, "Raw Data")),
                  (_openBlock(), _createElementBlock("option", _hoisted_19, "All Data")),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.task_rules, (taskRule) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: taskRule.TaskRuleID,
                      value: [taskRule.TaskRuleID]
                    }, _toDisplayString(taskRule.Name), 9, _hoisted_20))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.DataTaskRuleIDs]
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("div", null, [
              _cache[24] || (_cache[24] = _createElementVNode("div", { class: "text h5" }, "Parameters", -1)),
              _createElementVNode("table", _hoisted_21, [
                _cache[23] || (_cache[23] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", { scope: "col" }, "Parameter"),
                    _createElementVNode("th", { scope: "col" }, "Value")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parameters, (value, key) => {
                    return (_openBlock(), _createElementBlock("tr", { key: key }, [
                      _createElementVNode("th", _hoisted_22, _toDisplayString(key), 1),
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          class: _normalizeClass(`form-control ${_ctx.isValidJSON(_ctx.parameters[key]) ? '' : 'is-invalid'}`),
                          type: "text",
                          id: "desc",
                          "onUpdate:modelValue": ($event: any) => ((_ctx.parameters[key]) = $event)
                        }, null, 10, _hoisted_23), [
                          [_vModelText, _ctx.parameters[key]]
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ], 512), [
              [_vShow, _ctx.parameters && Object.entries(_ctx.parameters).length]
            ]),
            _cache[35] || (_cache[35] = _createElementVNode("div", { class: "text h5" }, "Sensor Tags", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tagSets, (draft, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                (_ctx.tagSets.length > 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("small", _hoisted_25, "Condition " + _toDisplayString(index + 1), 1),
                      _createElementVNode("button", {
                        class: "btn btn-sm btn-outline-danger",
                        type: "button",
                        onClick: ($event: any) => (_ctx.removeTagSet(index))
                      }, [
                        _createVNode(_component_vue_feather, {
                          type: "x",
                          size: "14"
                        }),
                        _cache[25] || (_cache[25] = _createTextVNode(" Remove ", -1))
                      ], 8, _hoisted_26)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("ul", _hoisted_29, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(draft.tags), (tag) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: "list-group-item d-flex justify-content-between align-items-center p-1",
                          key: tag[0]
                        }, [
                          _createTextVNode(_toDisplayString(tag[0]) + ": " + _toDisplayString(tag[1]) + " ", 1),
                          _createElementVNode("button", {
                            class: "btn btn-sm btn-outline-danger",
                            onClick: ($event: any) => (delete draft.tags[tag[0]])
                          }, [
                            _createVNode(_component_vue_feather, { type: "trash" })
                          ], 8, _hoisted_30)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _cache[26] || (_cache[26] = _createElementVNode("div", { class: "input-group-text" }, "Tag", -1)),
                      _withDirectives(_createElementVNode("select", {
                        class: "form-control",
                        "onUpdate:modelValue": ($event: any) => ((draft.selectTag) = $event),
                        onChange: ($event: any) => (draft.selectTagValue = '')
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredTagOptionsForSet(draft), (tag) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: tag,
                            value: tag
                          }, _toDisplayString(tag), 9, _hoisted_34))
                        }), 128))
                      ], 40, _hoisted_33), [
                        [_vModelSelect, draft.selectTag]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _cache[27] || (_cache[27] = _createElementVNode("div", { class: "input-group-text" }, "Value", -1)),
                      _withDirectives(_createElementVNode("select", {
                        class: "form-control",
                        "onUpdate:modelValue": ($event: any) => ((draft.selectTagValue) = $event),
                        disabled: draft.selectTag === '' ? true : false
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sensorTagOptions[draft.selectTag], (tagValue) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: tagValue,
                            value: tagValue
                          }, _toDisplayString(tagValue), 9, _hoisted_37))
                        }), 128))
                      ], 8, _hoisted_36), [
                        [_vModelSelect, draft.selectTagValue]
                      ]),
                      _createElementVNode("button", {
                        class: "btn btn-outline-success",
                        type: "button",
                        onClick: ($event: any) => (_ctx.addRuleTag(draft)),
                        disabled: draft.selectTagValue === '' ? true : false
                      }, [
                        _createVNode(_component_vue_feather, { type: "plus" })
                      ], 8, _hoisted_38)
                    ])
                  ])
                ]),
                (index < _ctx.tagSets.length - 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, "— OR —"))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            _createElementVNode("button", {
              class: "btn btn-sm btn-outline-secondary mb-3",
              type: "button",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.addTagSet && _ctx.addTagSet(...args)))
            }, [
              _createVNode(_component_vue_feather, {
                type: "plus",
                size: "14"
              }),
              _cache[28] || (_cache[28] = _createTextVNode(" Add OR condition ", -1))
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _cache[29] || (_cache[29] = _createElementVNode("div", { class: "input-group-text" }, "Start", -1)),
                _createVNode(_component_datepicker, {
                  typeable: "",
                  inputFormat: _ctx.dateFormat,
                  class: "form-control",
                  style: {"width":"158px","border-top-left-radius":"0","border-bottom-left-radius":"0"},
                  modelValue: _ctx.pickerStartDate,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.pickerStartDate) = $event)),
                  onfocusout: _ctx.push_end_date(),
                  minimumView: "time"
                }, null, 8, ["inputFormat", "modelValue", "onfocusout"])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _cache[30] || (_cache[30] = _createElementVNode("div", { class: "input-group-text" }, "End", -1)),
                _createVNode(_component_datepicker, {
                  typeable: "",
                  inputFormat: _ctx.dateFormat,
                  class: "form-control",
                  style: {"width":"167px","border-top-left-radius":"0","border-bottom-left-radius":"0"},
                  disabled: !_ctx.endDate,
                  modelValue: _ctx.pickerEndDate,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.pickerEndDate) = $event)),
                  "lower-limit": _ctx.pickerStartDate,
                  minimumView: "time"
                }, null, 8, ["inputFormat", "disabled", "modelValue", "lower-limit"])
              ])
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _cache[31] || (_cache[31] = _createElementVNode("div", { class: "input-group-text" }, "Max Concurrent", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  type: "number",
                  min: "1",
                  placeholder: "Unlimited",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.maxConcurrent) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.maxConcurrent]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "form-check-input",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.enabled) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.enabled]
              ]),
              _cache[32] || (_cache[32] = _createElementVNode("label", { class: "form-check-label" }, "Enabled?", -1))
            ]),
            _createElementVNode("div", _hoisted_46, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "form-check-input",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.endDate) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.endDate]
              ]),
              _cache[33] || (_cache[33] = _createElementVNode("label", { class: "form-check-label" }, "End Date?", -1))
            ]),
            _createElementVNode("div", _hoisted_47, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "form-check-input",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.multipleTruePerBatch) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.multipleTruePerBatch]
              ]),
              _cache[34] || (_cache[34] = _createElementVNode("label", { class: "form-check-label" }, "Multiple per batch?", -1))
            ])
          ], 32)
        ]),
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary",
            "data-dismiss": "modal",
            onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.clearSelectedRule && _ctx.clearSelectedRule(...args)))
          }, "Close"),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.save_rule && _ctx.save_rule(...args)))
          }, "Save changes")
        ])
      ])
    ])
  ]))
}